import noop from 'lodash/noop';
import { connect } from 'formik';
import { useEffect } from 'react';

import { FormikDropdownMenuSelector } from 'shared/components/DropdownMenuSelector';
import { IMenuItem } from 'shared/types/MenuItem';
import { t } from 'localization/utils/t';

const TP = 'checkout.components.AddressForm';

interface CountryDropdownFieldProps {
  className?: string;
  countriesList: Array<IMenuItem>;
  formik?;
  onMenuItemClick(params: IMenuItem): void;
  selectedCountry: IMenuItem;
}

export const CountryDropdownField = ({
  className,
  countriesList,
  onMenuItemClick = noop,
  selectedCountry,
  formik,
}: CountryDropdownFieldProps) => {
  useEffect(() => {
    if (selectedCountry && selectedCountry.value) {
      formik.setTouched = true;
      formik.setFieldValue('countryCode', selectedCountry.value);
    }
  }, [selectedCountry]);

  return (
    <FormikDropdownMenuSelector
      className={className}
      data-qa="checkout_shipping_country_selector"
      label={t(`${TP}.country`, 'Country')}
      menuItems={countriesList}
      name="countryCode"
      onMenuItemClick={onMenuItemClick}
      selection={selectedCountry}
    />
  );
};

export default connect(CountryDropdownField);
